import { useCurrentLanguage, useTranslator } from 'tradera/lang/translate';

export const useTimeSinceShortFormat = (dateString: string) => {
    const { t } = useTranslator();
    const { language } = useCurrentLanguage();
    const date = new Date(dateString);
    const now = new Date();

    const secondsSinceDate = Math.round(
        (now.getTime() - date.getTime()) / 1000
    );
    if (secondsSinceDate < 45) return t('notificationsSideSheet_now');

    const minutesSinceDate = Math.round((secondsSinceDate - 15) / 60);
    if (minutesSinceDate < 45)
        return t('notificationsSideSheet_minutesShort', {
            count: minutesSinceDate
        });

    const hoursSinceDate = Math.round((minutesSinceDate - 15) / 60);
    if (hoursSinceDate < 24)
        return t('notificationsSideSheet_hoursShort', {
            count: hoursSinceDate
        });

    const daysSinceDate = Math.round((hoursSinceDate - 6) / 24);
    if (daysSinceDate <= 14)
        return t('notificationsSideSheet_daysShort', { count: daysSinceDate });

    return date.toLocaleDateString(language ?? 'sv-SE', {
        day: 'numeric',
        month: 'short'
    });
};
